<template>
  <div id="advantage" class="text-center">
    <h2>{{ $t('ourAdvantage') }}</h2>
    <div class="list">
      <div v-for="item in advantageList" :key="item.title" class="item">
        <img :src="item.imgUrl" :alt="item.imgAlt">
        <p class="little-title">{{ item.title }}</p>
        <p class="describe">{{ item.describe }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'affiliate-advantage',
    locales,
    data: function () {
      return {
        advantageList: [{
          imgUrl: '/static/img/affiliate/join_for_free.png',
          imgAlt: 'Join for free',
          title: this.$t('joinForFree'),
          describe: this.$t('freeInfo')
        }, {
          imgUrl: '/static/img/affiliate/higher_conversion_rate.png',
          imgAlt: 'Higher conversion rate',
          title: this.$t('higherConversionRate'),
          describe: this.$t('conversionInfo')
        }, {
          imgUrl: '/static/img/affiliate/sell_globally.png',
          imgAlt: 'Sell globally',
          title: this.$t('sellGlobally'),
          describe: this.$t('globallyInfo')
        }
        ],
        isIE11: false
      }
    },
    mounted() {
      this.isIE11 = navigator.userAgent.indexOf('Trident') > -1
    }

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    margin: 0;
    padding: 0;
  }

  #advantage {
    margin-top: 180px;
  }

  h2 {
    font-size: 40px;
    color: #111111;
    letter-spacing: 2px;
    line-height: 40px;
    font-weight: 600;
    padding-bottom: 24px;
    background: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%) center bottom / 60px 4px no-repeat;
  }
  
  .list {
    margin-top: 80px;
    display: flex;
    justify-content: space-between;
    .item {
      width: 30%;
      img {
        display: block;
        width: 50px;
        height: 50px;
        margin: 0 auto;
      }
      .little-title {
        margin: 16px 0 12px;
        font-size: 24px;
        color: #333333;
        line-height: 32px;
        font-weight: 600;
        text-align: center;
      }
      .describe {
        font-size: 16px;
        color: #666666;
        line-height: .24rem;
      }
    }
  }

  @media (max-width: 911px) {
    #advantage {
      margin-top: 80px;
    }
  }
  
  @media (max-width: 767px) {
    h2 {
      font-size: 24px;
      line-height: 32px;
      padding-bottom: 16px;
      background-size: 40px 4px;
    }
    .list {
      margin-top: 0;
      display: block;
      .item {
        width: 100%;
        margin-top: 40px;
        img {
          width: 64px;
          height: 64px;
        }
        .little-title {
          margin: 24px 0 8px;
          font-size: 18px;
          line-height: 24px;
        }
        .describe {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Advantage.vue?19ae5bf5